// Structured Data for PAK School & College System

export const getSchoolStructuredData = () => {
  return {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "PAK School & College System",
    "alternateName": "PAK School and College",
    "description": "PAK School & College System offers quality education with modern facilities, experienced teachers, and comprehensive academic programs for students from nursery to college level.",
    "url": "https://pakschoolandcollege.com",
    "logo": "https://pakschoolandcollege.com/logo.png",
    "image": "https://pakschoolandcollege.com/assets/hero-banner.jpg",
    "telephone": "+92-XXX-XXXXXXX",
    "email": "info@pakschoolandcollege.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "School Address",
      "addressLocality": "City",
      "addressRegion": "Province",
      "postalCode": "XXXXX",
      "addressCountry": "PK"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "XX.XXXX",
      "longitude": "XX.XXXX"
    },
    "foundingDate": "2020",
    "educationalLevel": ["Elementary", "Secondary", "Higher Education"],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Academic Programs",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Course",
            "name": "Nursery Program",
            "description": "Early childhood education program"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Course",
            "name": "Primary Education",
            "description": "Grades 1-5 comprehensive education"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Course",
            "name": "Secondary Education",
            "description": "Grades 6-10 academic program"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Course",
            "name": "Higher Secondary",
            "description": "Grades 11-12 college preparation"
          }
        }
      ]
    },
    "sameAs": [
      "https://www.facebook.com/pakschoolandcollege",
      "https://www.instagram.com/pakschoolandcollege",
      "https://www.twitter.com/pakschoolcollege"
    ]
  };
};

export const getBreadcrumbStructuredData = (breadcrumbs) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": crumb.name,
      "item": crumb.url
    }))
  };
};

export const getEventStructuredData = (event) => {
  return {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": event.title,
    "description": event.description,
    "startDate": event.startDate,
    "endDate": event.endDate,
    "location": {
      "@type": "Place",
      "name": "PAK School & College System",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "School Address",
        "addressLocality": "City",
        "addressRegion": "Province",
        "postalCode": "XXXXX",
        "addressCountry": "PK"
      }
    },
    "organizer": {
      "@type": "Organization",
      "name": "PAK School & College System",
      "url": "https://pakschoolandcollege.com"
    },
    "image": event.image ? `https://pakschoolandcollege.com${event.image}` : "https://pakschoolandcollege.com/assets/hero-banner.jpg"
  };
};

export const getArticleStructuredData = (article) => {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": article.title,
    "description": article.description,
    "image": article.image ? `https://pakschoolandcollege.com${article.image}` : "https://pakschoolandcollege.com/assets/hero-banner.jpg",
    "datePublished": article.publishedDate,
    "dateModified": article.modifiedDate || article.publishedDate,
    "author": {
      "@type": "Organization",
      "name": "PAK School & College System"
    },
    "publisher": {
      "@type": "Organization",
      "name": "PAK School & College System",
      "logo": {
        "@type": "ImageObject",
        "url": "https://pakschoolandcollege.com/logo.png"
      }
    }
  };
};

export const getFAQStructuredData = (faqs) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
};
